<template>
    <div id="content" v-show="!loading">
        <form>
            <div class="inner">
                <p class="paging">
                    <router-link
                            :to="{ name: moduleName }"
                            class="btn btn_back"
                            v-translate>Seznam
                    </router-link>
                </p>
                <p class="buttons" v-if="$_updateActionAllowed">
                    <a
                            v-if="!isActive"
                            class="btn btn_action btn_grey btn_enable"
                            :title="'Aktivovat' | translate"
                            @click.prevent.stop="updateEntityActive('enabled', true)"
                            v-translate>Aktivovat
                    </a>
                    <a
                            v-else
                            class="btn btn_action btn_grey btn_disable"
                            :title="'Deaktivovat' | translate"
                            @click.prevent.stop="updateEntityActive('enabled', false)"
                            v-translate>Deaktivovat
                    </a>
                </p>
                <h1>{{ entity.title }}</h1>
            </div>

            <div class="responsiveTabs">
                <ul class="tabs">
                    <li :class="getActiveTabClass('settings')">
                        <a @click.prevent.stop="activateTab('settings')" v-translate>Vlastnosti</a>
                    </li>
                    <li :class="getActiveTabClass('runs')">
                        <a @click.prevent.stop="activateTab('runs')" v-translate>Historie</a>
                    </li>
                </ul>

                <div class="tabs_content" v-show="isActiveTab('settings')">
                    <section>
                        <div class="left">
                            <h2 v-translate>Základní údaje</h2>
                          <div v-if="$_updateActionAllowed">
                            <input
                                    v-if="entity.last_status === 'running'"
                                    type="submit"
                                    :class="['btn']"
                                    :value="$gettext('Odemknout')"
                                    @click.prevent.stop="unlockCron()">
                            <input
                                    v-else
                                    type="submit"
                                    :class="['btn']"
                                    :value="$gettext('Spustit')"
                                    @click.prevent.stop="runCron()">
                            </div>
                        </div>
                        <div class="right">
                            <div class="field_left">
                                <text-input
                                        id="crontitle"
                                        :required="true"
                                        v-model="entity.title"
                                        ref="crontitleref"
                                        :disabled="!$_updateActionAllowed"
                                ><translate class="translate">Název cronu</translate>
                                </text-input>
                                <text-input
                                        id="cronmaximuminactivitytime"
                                        :required="true"
                                        v-model="entity.maximum_inactivity_time"
                                        ref="cronmaximuminactivitytimeref"
                                        :disabled="!$_updateActionAllowed"
                                ><translate class="translate">Maximální doba neaktivity (sekundy)</translate>
                                </text-input>
                                <text-input
                                        id="cronmaximumruntime"
                                        :required="true"
                                        v-model="entity.maximum_runtime"
                                        ref="cronmaximumruntimeref"
                                        :disabled="!$_updateActionAllowed"
                                ><translate class="translate">Maximální délka běhu (sekundy)</translate>
                                </text-input>
                            </div>
                            <div class="field_right">
                                <text-input
                                        id="cronname"
                                        :required="true"
                                        v-model="entity.name"
                                        ref="cronnameref"
                                        :disabled="true"
                                ><translate class="translate">Označení cronu</translate>
                                </text-input>
                                <text-input
                                        id="cronmaximumrunsperday"
                                        :required="true"
                                        v-model="entity.maximum_runs_per_day"
                                        ref="cronmaximumrunsperdayref"
                                        :disabled="!$_updateActionAllowed"
                                ><translate class="translate">Maximální počet běhů za den</translate>
                                </text-input>
                                <text-input
                                        id="cronexpectedruntime"
                                        :required="true"
                                        v-model="entity.expected_runtime"
                                        ref="cronexpectedruntimeref"
                                        :disabled="!$_updateActionAllowed"
                                ><translate class="translate">Očekávaná délka běhu</translate>
                                </text-input>
                            </div>
                            <div class="field">
                                <textarea-input
                                        id="note"
                                        name="note"
                                        rows="6"
                                        cols="50"
                                        v-model="entity.description"
                                        :disabled="!$_updateActionAllowed"
                                ><translate class="translate">Popis</translate>
                                </textarea-input>
                            </div>
                        </div>
                    </section>
                    <form-buttons
                            :module-name="moduleName"
                            :custom-submit-text="'Uložit vlastnosti' | translate"
                            @submit-form="submitForm"
                    ></form-buttons>
                </div>

                <div class="tabs_content" v-show="isActiveTab('runs')">
                    <cron-run-list></cron-run-list>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import FormButtons from "@/components/common/FormButtons"
	import detailActions from "@/components/mixins/detail-actions"
	import crons from "@/components/views/crons/mixins/crons"
    import CronRunList from "@/components/views/crons/CronRunList"

	export default {
		name: "CronDetail",
		mixins: [detailActions, crons],
		components: {
			CronRunList,
			FormButtons
		},
		data() {
			return {
				loading: true,
				prevRoute: null,
			}
		},
		created(CronService) {
			this.entityService = CronService
			this.createdInit()

			if (this.$route.name === 'cronDetailHistory') {
				this.activateTab('runs')
			}
		},
		beforeDestroy() {
			this.activateTab('settings')
		},
		computed: {
			isActive() {
				return this.entity.enabled
			}
		},
		methods: {
			runCron() {
				this.entity.last_status = 'running'

				this.setLoadingMessage()
				this.entityService.runCron(this.entity.id)
					.then(() => {
                        this.getEntity()
					})
					.catch(error => {
            if(error.error_message == "Cron run was skipped. This is not the primary server."){
              this.setErrorMessage(this.$gettext('Běh cronu byl přeskočen. Toto není primární server.'));
            }else {
              console.error(error)
              this.setErrorMessage(this.$gettext('Nastala chyba. Podívejte se do console logu.'))
            }
					})
			},
			unlockCron() {
				this.setLoadingMessage()
				this.entityService.unlockCron(this.entity.id)
					.then(() => {
						this.getEntity()
					})
					.catch(error => {
						console.error(error)
						this.setErrorMessage(this.$gettext('Nastala chyba. Podívejte se do console logu.'))
					})
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/crons/CronDetail.vue